import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { PATHS } from '@/constants/page-paths';
import { apiGetTwin } from '@/services/chat.api';
import { useChatStore } from '@/store';

export const useTwin = (twinName?: string) => {

  const defaultTwinId = 'sfs';
  console.log(twinName)

  const { state, pathname } = useLocation();

  const { brainId: newCatId } = state || {};

  // const { twinName, demoToken } = useParams();

  const { setCategory, category } = useChatStore();

  const navigate = useNavigate();

  // const twinParam = twinName || twin || savedTwin?.name;

  // const allowedPaths = [PATHS.CHAT, PATHS.SIGN_IN, PATHS.REGISTER];

  const { data, ...others } = useQuery({
    queryKey: ['twin', defaultTwinId],
    queryFn: () =>
      apiGetTwin({
        twinName: defaultTwinId,
      }),
    onSuccess: (res) => {
      // Updated to match the provided API response structure
      const categories = res?.data?.data?.categories;
      console.log('[useTwin] Setting categories:', categories);
      const defaultCat = categories?.find((cat) => cat.isDefault);

      if (newCatId) {
        const newCategory = categories?.find((i) => i?.brainId === newCatId);
        if (newCategory) {
          setCategory(newCategory);
          console.log('[useTwin] Setting newCategory from state:', newCategory, 'brainId:', newCatId);
        }
      } else {
        const isExistingCategoryValid = categories?.some(
          (i: Record<string, string>) => i?.brainId === category?.brainId
        );

        if (!isExistingCategoryValid) {
          setCategory(defaultCat);
          console.log('[useTwin] Setting default category:', defaultCat);
        } else {
          const cat = categories?.find(
            (i: Record<string, string>) => i?.brainId === category?.brainId
          );
          setCategory(cat);
          console.log('[useTwin] Setting existing category:', cat);
        }
      }
    },
    onError: () => {
      if (
        pathname === PATHS.CHAT ||
        pathname.startsWith('/chat/') ||
        pathname.startsWith('/twin-demo/')
      ) {
        navigate(PATHS.HOME);
      }
    },
    refetchOnWindowFocus: false,
   
  });

  const twinData = data?.data?.data;

  return {
    twinData,
    ...others,
  };
};
